import { Button } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { SendlaneIcon } from '@mm/icons';
import { selectCrmsLeadsSent } from '@mm/state/selectors/connectionsSelectors';
import React, { useEffect } from 'react';
import { ButtonColor } from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { BaseIntegration } from '../../../BaseIntegration/BaseIntegration';
import { BaseIntegrationHeader } from '../../../BaseIntegration/BaseIntegrationHeader';
import { useFetchConnections } from '../../../use-fetch-connections';
import { SendlaneSettings } from './SendlaneSettings';
import { useSelector } from 'react-redux';
import { TeamOutlined } from '@ant-design/icons';
import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';
import { Help } from '../KlaviyoIntegrations/KlaviyoHelpLink';

const header = (leadsSent?: number) => (
  <div className="integrations__header-actions">
    <Help
      link="https://customers.ai/help/l/en/article/jb7zslbl8x-sendlane-integration"
      text="Help Center"
    />
    {!!leadsSent && (
      <div className="integrations__header-status">
        <TeamOutlined className="integrations__header-status-icon" />
        <div className="integrations__header-status-count">{leadsSent}</div>
        Leads sent
      </div>
    )}
    <Button
      css={{ container: 'integrations__header-add-button-secondary' }}
      onClick={e => {
        e?.stopPropagation();
        window.open('https://app.sendlane.com/api', '_blank');
      }}
      color={ButtonColor.secondaryBlue}
    >
      Add a Connection
    </Button>
  </div>
);

export const SendlaneIntegrations = () => {
  const { fetch } = useFetchConnections();

  const sectionProps = {
    landmineName: landmineNames.SENDLANE_UPGRADE,
    featureFlag: 'nativeIntegrations',
  };

  useEffect(() => {
    fetch(1, 200, 'sendlane');
  }, [fetch]);

  const crmsLeadsSent = useSelector(selectCrmsLeadsSent);
  const leadsSent = crmsLeadsSent?.sendlaneContactsSent;

  const { companyName = 'Customers.ai' } = useWhitelabelConfig();

  return (
    <BaseIntegration
      titleComponent={
        <BaseIntegrationHeader
          title="Sendlane"
          upgradeButtonName="Add a Connection"
          subtitle={`Automatically sync your ${companyName} contacts to Sendlane`}
          icon={<SendlaneIcon />}
          headerRightComponent={header(leadsSent)}
          css={{ icon: 'integrations__sendlane-header-icon' }}
          {...sectionProps}
        />
      }
      integrationType="sendlane"
    >
      <SendlaneSettings />
    </BaseIntegration>
  );
};
